import styled from 'styled-components';

export const StyledOverviewFive = styled.section`
    padding-top: 200px;
    padding-bottom: 200px;
    background-image: url("/images/static/career.jpg");
    background-repeat: no-repeat !important;
    background-size: cover !important;
    background-position: center;
    //background-position: top right;
    //background-blend-mode: hard-light;
    position: relative;
    z-index: -1;
    .fixed-left {
        position: absolute;
        top: 0;
        left: ${props => props.offset + 15 || 0}px;
        z-index: -1 !important;

    }

    .fixed-right {
        position: absolute;
        bottom: -100px;
        right: -100px;
        z-index: 1;
    }


    &:after {
        position: absolute;
        bottom: -${props => props.ribon + 'px' || '50svh'};
        content: '';
        background: #EFEFEF;
        height: ${props => props.ribon + 'px' || '50svh'};
        width: calc(100% + ${props => props.offset + 15 || 0}px);
        left: -${props => props.offset + 15 || 0}px;
        right: 0;
        z-index: -1;
    }

    .subtitle-ygen {
        color: rgba(21, 38, 55, 0.5);
        font-size: 1rem; /* 16px / 16 */
        font-style: normal;
        font-weight: 500;
        line-height: 1.5rem; /* 24px / 16 */
        margin-bottom: 40px;
    }

    @media (max-width: 767px) {
        padding: 100px 0;
        .subtitle-ygen {
            margin-bottom: 30px;
        }

        .title {
            margin-bottom: 30px;
        }
    }

`;
